// extracted by mini-css-extract-plugin
export default {"documentState":"documentState--_BqCj","fullScreen":"fullScreen--_ITdc","hidden":"hidden--_JnZh"};